/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_RevokeInputs */

const en_invite_revoke = /** @type {(inputs: Invite_RevokeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revoke`)
};

const de_invite_revoke = /** @type {(inputs: Invite_RevokeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurückziehen`)
};

/**
* | output |
* | --- |
* | "Revoke" |
*
* @param {Invite_RevokeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const invite_revoke = /** @type {((inputs?: Invite_RevokeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_RevokeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_invite_revoke(inputs)
	return en_invite_revoke(inputs)
});